import { getReservationTotals, round } from '../../utils/utils';
import { getPrice } from '@synergycms_core/utils/utils';
import {  is } from 'ramda';
import {  List } from 'immutable';
import { STAR_TRAVELER_MAX_ROOMS_POINTS } from './loyaltyActions';

export const getSTPoints = (store,showFrontRedeemPoints = false)=> {
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);
  const reservationObj = store.getIn(['customer', 'reservation'], false);
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);
  let accumulatePoints = null;
  if(loyalty && ["customerForm", "confirmation"].includes(stepCode)) {
    accumulatePoints = reservationObj.getIn(["loyalty", showFrontRedeemPoints ? "accumulated_points_front" : "accumulated_points"], 0);
  }
  else if(loyalty) {
    const currencies = store.getIn(["customer", "currencies"]);
    const hotelCurrencyCode = store.getIn(['hotels', store.getIn(['customer', 'current_hotel']), 'currency', 'code']);
    const originCurrency = currencies.find(c => c.get('code') === hotelCurrencyCode);
    const destCurrency = currencies.find(c => c.get('code') === "EUR");

    const reservationRequest = store.getIn(['customer', 'reservation_request']);
    const reservation = store.getIn(['customer', 'reservation'], false);
    const reservationBlocks = !!reservationRequest.get("loyalty") && reservationRequest?.getIn(['blocks']);

    let reservationTotals;

    if(reservationBlocks && reservationBlocks.size > STAR_TRAVELER_MAX_ROOMS_POINTS) {
      //Obtenemos la primera habitacion seleccionada
      const firstRoom = reservationBlocks.first();
      //Obtenemos la habitacion mas cara, excluyendo la primera habitacion
      const expensiveRoom = reservationBlocks.shift().maxBy((room) => {
        const totalPrice = getReservationTotals(store, true, List([room]));
        return totalPrice.get('total_price', 0);
      });

      const finalList = List([firstRoom,expensiveRoom]);
      reservationTotals = finalList && is(List, finalList) && finalList.size > 0 && getReservationTotals(store, true, finalList);

    }else{
      reservationTotals = reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store, true);
    }

    let totalPrice = reservationTotals && parseFloat(reservationTotals.get('total_price', 0));
    if(reservation){
      const totalPointsPrice = reservation.getIn(['loyalty', 'total_points_price'], 0);
      //const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
      totalPrice = Math.max(0, round(totalPrice - totalPointsPrice));
    }
    accumulatePoints  = round(getPrice(totalPrice, originCurrency.get('ratio'), destCurrency.get('ratio')) * loyalty.get("accumulate_ratio"), 0);
  }


  return accumulatePoints;
}


export const getLoyaltyTier = (store,loyalty = null, getDefault = false) => {

  return (!getDefault && store.getIn(['customer', 'loyalty', 'user', 'tier', 'current'], null)) // current user tier
    || loyalty?.getIn(['loyalty', 'tier'],null)
    || store.getIn(['customer', 'loyalty', 'descriptives', store.getIn(['customer', 'current_hotel']), 'loyalty', 'tier'], null) // hotel tier (monoHotel)
    || store.getIn(['customer', 'loyalty', 'descriptives', store.get("group"), 'loyalty', 'tier'], null); // group tier ( multiHotel )
}
